const replaceParam = (path:string, paramName:string, paramValue:string, altPath:string) => {
  if (path && paramValue && path.includes(`:${paramName}`)) {
    const cleanedValue = paramValue.replace("?", "");
    if (cleanedValue !== "") {
      return path.replace(`:${paramName}`, cleanedValue);
    } else if (altPath) {
      return altPath;
    }
  }
  return path;
};

function ReturnSpecificCases({ ReturnPath, ReturnPathAlt,...param }: any): string {
    
  let _returnPath: string;
    _returnPath = ReturnPath;

    _returnPath = replaceParam(_returnPath, "id", param?.params?.id, ReturnPathAlt);
    _returnPath = replaceParam(_returnPath, "ean", param?.params?.ean, ReturnPathAlt);
    _returnPath = replaceParam(_returnPath, "idmarque", param?.params?.idmarque, ReturnPathAlt);
    _returnPath = replaceParam(_returnPath, "idnotice", param?.params?.Id, ReturnPathAlt); //à voir ??
    _returnPath = replaceParam(_returnPath, "idnotice", param?.params?.idnotice, ReturnPathAlt);
   
  
    return _returnPath;
  }
  
  export default ReturnSpecificCases;
  